import { LicenseEntity, LicenseEntityJson } from "@youm-front/license/domain";

export function buildLicenseEntity(
  licenseEntityJson: LicenseEntityJson
): LicenseEntity {
  return new LicenseEntity(licenseEntityJson);
}
